import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useRouter } from "next/router";
import { getPublicPathFromAsPath } from "@/lib/publicPath";

/**
 * Next.js may append dynamic segment names to the query string after hydration.
 * Use History API only — router.replace() triggers "hard navigate to same URL".
 */
export function RouteUrlCleanup() {
  const $ = _c(5);
  const router = useRouter();
  let t0;
  if ($[0] !== router.isReady) {
    t0 = () => {
      if (!router.isReady || typeof window === "undefined") {
        return;
      }
      const browserUrl = `${window.location.pathname}${window.location.search}`;
      const clean = getPublicPathFromAsPath(browserUrl);
      if (browserUrl === clean) {
        return;
      }
      window.history.replaceState(window.history.state, "", clean);
    };
    $[0] = router.isReady;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== router.asPath || $[3] !== router.isReady) {
    t1 = [router.isReady, router.asPath];
    $[2] = router.asPath;
    $[3] = router.isReady;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useEffect(t0, t1);
  return null;
}